/* Названия узлов дерева заводит заказчик, и они бывают двух видов:
   «ФП-01 · Фрезерный ЧПУ» с кодом внутри и просто «Фрезерный ЧПУ».

   Везде, где рядом уже стоит код, повтор съедает ширину — а обрезается при
   этом именно содержательная часть: «ШТ-01 · Пре…». Поэтому код остаётся
   всегда, а из названия снимается ровно точный префикс «<код><разделитель>».
   Назвал заказчик узел иначе — название остаётся нетронутым.

   Сравниваем строками, а не собранной регуляркой: код может содержать точку
   или скобку, и экранировать их ради одной проверки префикса незачем.

   Полное значение всё равно обязано быть доступно по наведению: сокращение
   здесь — экономия места, а не решение, что человеку показывать. */
export function shortEquipmentName(code, name) {
  const n = String(name || '').trim();
  const c = String(code || '').trim();
  if (!c || !n.toLowerCase().startsWith(c.toLowerCase())) return n;
  const rest = n.slice(c.length).replace(/^\s*[·—–-]?\s*/, '');
  return rest || n;
}
